export default "* Hvad er et kunstværk?\n* Hvad er god etik i forhold til den døde fisk?\n* Hvad er en fladfisk?\n* Hvad er en rundfisk?";